import type { SessionStatus } from '@hoopify/shared';

export function StatusBadge({ status }: { status: SessionStatus }) {
  return status === 'draft' ? (
    <span className="inline-flex rounded border border-dashed border-line-strong px-1.5 text-[11px] leading-[18px] font-medium text-muted">Draft</span>
  ) : null;
}
